import {BrowserUtil} from "./../../../utils/BrowserUtil";
import {EnvGlobalsHandler} from "../../EnvGlobalsHandler";
import {JavascriptFunctionName} from "../externalInterface/JavascriptFunctionName";
import {BasicModel} from "../../model/BasicModel";
import {SimpleCommand} from "./../../../commanding/SimpleCommand";
import {URLRequest, ExternalInterface} from "@goodgamestudios/createjs-utilities";

import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("BasicOpenForumCommand");

/**
 * <p>Opens the forum or a group (depending on the network settings).
 * You my configure a specific sub forum with a ForumLinkVO. URL will be composed automatically</p>
 *
 * Open forum:
 * <code>CommandController.instance.executeCommand(BasicController.COMMAND_OPEN_FORUM);</code>
 *
 * Open sub forum (with the help of a ForumLinkVO):
 * <code>CommandController.instance.executeCommand(BasicController.COMMAND_OPEN_FORUM,new ForumLinkVO(Constants_URL.FORUM_ID_ANNOUNCEMENT));</code>
 */
export class BasicOpenForumCommand extends SimpleCommand {
    public /*final*/ execute(commandVars: any = null): void {
        // Request group via Javascript
        if (EnvGlobalsHandler.globals.networkNewsByJS) {
            ExternalInterface.call(JavascriptFunctionName.REQUEST_GROUP);
        }
        // Request default forum link  // If links are allowed in this network
        else if (EnvGlobalsHandler.globals.useexternallinks) {
            this.goForum();
        } else {
            logger.debug("BasicOpenForumCommand - unhandled else case");
        }
    }

    private goForum(): void {
        let forumURL: string;

        // Forum root
        forumURL = BasicModel.forumData.getForumRootURL();

        let request: URLRequest = new URLRequest(forumURL);
        BrowserUtil.executeNavigateToURL(request, "_blank");
    }

}
